import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output, signal, TemplateRef} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {NgTemplateOutlet} from '@angular/common';

@Component({
  selector: 'app-nested-expansion-panel',
  templateUrl: './nested-expansion-panel.component.html',
  styleUrls: ['./nested-expansion-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('nestedExpandCollapsePanel', [
      state(
        'expanded',
        style({
          height: '*',
        })
      ),
      state(
        'hidden',
        style({
          height: '0px',
        })
      ),
      transition('expanded <=> hidden', [animate(`500ms ease-in`)]),
    ])
  ],
  imports: [NgTemplateOutlet],
})
export class NestedExpansionPanelComponent {
  /** Contain default value for the expand panel controller. */
  @Input() defaultPanelStatus = false;

  /** Contain reference to the header template. */
  @Input() headerTemplate: TemplateRef<any>;

  /** Defines where the header template should be placed: before or after the provided content. */
  @Input() headerPosition: 'before' | 'after' = 'before';

  /**
   * Current panel status.
   */
  @Output() panelStatus = signal(this.defaultPanelStatus);

  /** Notify parent component that expand or collapse animation has finished. */
  @Output() animationFinished = new EventEmitter<boolean>();

  public expandPanel(): void {
    this.panelStatus.set(true);
  }

  public togglePanel(): void {
    this.panelStatus.set(!this.panelStatus());
  }

  public collapsePanel(): void {
    this.panelStatus.set(false);
  }
}
